<template>
  <app-page title="Home" v-bind:large="false">
    <md-progress v-if="!$root.userData" md-indeterminate></md-progress>

    <md-list class="md-triple-line" v-if="$root.userData">
      <md-list-item
        v-for="(value, key) in $root.userData.lists"
        v-bind:key="key"
        ><router-link v-bind:to="{ name: 'list', params: { id: key } }">{{
          value.name
        }}</router-link></md-list-item
      >
    </md-list>

    <img src="../assets/Shopping_cart_with_food_clip_art_2.svg" />
  </app-page>
</template>

<script>
export default {};
</script>

<style scoped>
.md-list-item {
  background: linear-gradient(135deg, #83c783 0%, #005700 100%);
  margin-bottom: 20px;
  box-shadow: 1px 1px 2px 1px #9e9e9e;
}
</style>
